export const isSSR = typeof window === 'undefined';

export function getQueryString(params: any) {
  // check that params object has at least one truthy value
  if (!params || !Object.values(params).filter((p) => !!p).length) {
    return '';
  }
  const esc = encodeURIComponent;
  return `?${Object.keys(params)
    .filter((param) => params[param] !== null && params[param] !== undefined)
    .map((param) => `${esc(param)}=${esc(params[param])}`)
    .join('&')}`;
}

export function sanitize(description: string | null) {
  return description?.replace(/<[^>]*>?/gm, '');
}

/**
 * Platform types that the application can run on
 */
export type Platform = 'ios_app' | 'android_app' | 'web';

/**
 * Detects the current platform the application is running on
 * @returns The current platform: 'ios_app', 'android_app', or 'web'
 */
export function getPlatform(): Platform {
  if (isSSR) {
    return 'web'; // Default to web during server-side rendering
  }

  // Check localStorage for platform flags
  const platformFromStorage =
    localStorage.getItem('platform') ||
    localStorage.getItem('bitecritic_platform');

  if (platformFromStorage === 'ios_app') {
    return 'ios_app';
  } else if (platformFromStorage === 'android_app') {
    return 'android_app';
  }

  return 'web';
}

/**
 * Checks if the application is running in a native mobile app
 * @returns true if running in iOS or Android app, false otherwise
 */
export function isNativeApp(): boolean {
  const platform = getPlatform();
  return platform === 'ios_app' || platform === 'android_app';
}

/**
 * Checks if the application is running in a web browser
 * @returns true if running in a web browser, false if in native app
 */
export function isWebBrowser(): boolean {
  return getPlatform() === 'web';
}


// Utility function to extract city from address
export const extractCityFromAddress = (address?: string): string => {
  if (!address) return '';

  // Split by comma and get the first group
  const addressParts = address.split(',');
  const firstGroup = addressParts[addressParts.length - 2];
  if (!firstGroup) return '';

  // Split by space and get the last part
  const parts = firstGroup.split(' ');
  const city = parts[parts.length - 1];

  return city || '';
};
